<script>
import { VMenu } from 'vuetify/lib';

export default {
  extends: VMenu,
  methods: {
    genActivatorListeners() {
      const listeners = VMenu.options.methods.genActivatorListeners.call(this);

      listeners.contextmenu = e => {
        const activator = this.getActivator(e);
        if (activator) activator.focus();

        e.stopPropagation();
        e.preventDefault();

        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;

        this.isActive = true;
      };
      delete listeners.click;

      return listeners;
    },
    genDirectives() {
      const directives = VMenu.options.methods.genDirectives.call(this);

      directives.push({
        name: 'context-outside',
        value: {
          handler: e => {
            const activator = this.getActivator(e);

            // if event contains activator, transition to new position instead of close
            if (e.target === activator || activator.contains(e.target)) {
              this.absoluteX = e.clientX;
              this.absoluteY = e.clientY;
              this.updateDimensions();
              return;
            }

            this.isActive = false;
          },
          closeConditional: this.closeConditional,
          include: () => [this.$el, ...this.getOpenDependentElements()],
        },
      });

      return directives;
    },
  },
};
</script>

<style lang="scss" scoped></style>
